import { Api } from '../api';
import { cards } from '../endpoints';
import type { AddCardRequest, GetCardsResponse, TopUpRequest, TopUpResponse } from './models';

export class CardsApi extends Api {
  static getCards = (signal?: AbortSignal) => this.get<GetCardsResponse[]>(cards.cards(), { signal });

  static addCard = (request: AddCardRequest, signal?: AbortSignal) =>
    this.post<undefined>(cards.addCard(), request, { responseType: 'none', signal });

  static downloadStatement = (id: string, token: string, signal?: AbortSignal) =>
    this.get<Blob>(cards.downloadStatement(id, token), { signal, responseType: 'blob' });

  static topUp = ({ cardId, ...data }: TopUpRequest, signal?: AbortSignal) => this.post<TopUpResponse>(cards.topUp(cardId), data, { signal });
}
